/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * This file defines and exports the AnalyticsContext object.
 * Separating the context object into its own file is a best practice
 * that satisfies strict ESLint rules like `react-refresh/only-export-components`.
 */
import { createContext } from 'react';

// This is the raw context object that will be shared across components.
export const AnalyticsContext = createContext();
